import classNames from "classnames"
import { Button } from "reactstrap"

import { useTooltip } from "@services/tooltipHook"

interface IProps {
  children?: React.ReactNode
  additionalClassName?: string
  disabled?: boolean
  id?: string
  isActive: boolean
  isImage?: boolean
  onClick: any
  tooltipText?: string
  buttonRole?: "submit" | "button" | "reset" | undefined
}

/**
 * This components provides a single item of a set of categories as an clickable button.
 * The button's content is provided as a child and may be an image or text.
 */
const FilterItem: React.FC<IProps> = (props: IProps) => {
  const { children, additionalClassName = "", buttonRole = "button", onClick, id, isActive, disabled, isImage = false, tooltipText } = props
  const className = classNames(
    { "image-filteritem": isImage },
    { "text-filteritem": !isImage },
    { "image-filteritem--active": isImage && isActive },
    { "text-filteritem--active": !isImage && isActive },
    additionalClassName
  )

  const { tooltipTargetRef, ToolTip } = useTooltip(tooltipText)


  return <>
    <Button
      className={className}
      onClick={event => {
        onClick()
        event.preventDefault()
        event.stopPropagation()
      }}
      onKeyDown={event => {
        if (event.key === "Enter") {
          onClick()
          event.preventDefault()
          event.stopPropagation()
        }
      }}
      disabled={disabled}
      id={id}
      innerRef={tooltipTargetRef}
      role={buttonRole}
    >
      {children}
    </Button>
    {ToolTip}
  </>
}

export default FilterItem
